import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

//Components
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import MUITextFieldStyle from '../../MUIStyles/MUITextFieldStyle';
import CircularProgress from '@mui/material/CircularProgress';

// Queries
import getMisAtencionesComentarios from '../../Queries/getMisAtencionesComentarios';
import postAtencionesAltaComentario from '../../Queries/postAtencionesAltaComentario';
import getGlobal from '../../Queries/getGlobal';

// Styles
import styles from './chat.module.sass';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

export default function Chat(props) {
  const { t } = useTranslation('attentions');
  const [chatOpen, setChatOpen] = useState(false);
  const [comments, setComments] = useState([]);
  const [description, setDescription] = useState('');
  const [imagesrc, setImagesrc] = useState('');
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);

  const { open = chatOpen, setOpen = setChatOpen, rowSelected = [], setSessionMessage } = props;

  function handleDesc(e) {
    setDescription(e.target.value);
  }

  function handleClose() {
    setOpen(false);
  }

  function openImage(url) {
    window.open(url);
  }

  const getPtoducts = useCallback(async () => {
    const resp = await getGlobal({
      tmbservice: 'getDetalleAtencion',
      jsonBody: {
        atencionId: rowSelected?.folio ?? '',
      },
    });

    if (resp?.messageCode === 200) {
      setProducts(resp?.listProductosAtenciones ?? []);
    }
  }, [rowSelected?.folio]);

  const getComments = useCallback(async () => {
    setLoading(true);

    const response = await getMisAtencionesComentarios({
      jsonBody: { folio: rowSelected.folio },
    });

    const { comentarios = [], tipoMensaje = 'error', mensaje = '' } = response || {};

    setSessionMessage(mensaje);
    setComments(comentarios);

    if (tipoMensaje !== 'exito' && mensaje !== '498' && mensaje !== '499') {
      alert(mensaje);
    }
    setLoading(false);
  }, [rowSelected.folio, setSessionMessage]);

  async function sendComment() {
    if (!description) return;
    setLoading(true);
    let imagenBase64 = '';
    if (imagesrc) {
      const imagenTmp = imagesrc.split(',');
      if (imagenTmp.length > 1) imagenBase64 = imagenTmp[1];
    }

    const response = await postAtencionesAltaComentario({
      jsonBody: { tipo: '0', comentarios: description, folio: rowSelected.folio, imagenBase64 },
    });

    const { tipoMensaje = 'error', mensaje = 'error' } = response || {};

    setSessionMessage(mensaje);

    if (tipoMensaje !== 'exito' && mensaje !== '498' && mensaje !== '499') {
      alert(mensaje);
    }

    if (tipoMensaje === 'exito') {
      setImagesrc('');
      setDescription('');
      getComments();
    }
  }

  useEffect(() => {
    if (open) {
      getComments();
      getPtoducts();
    }
  }, [getComments, getPtoducts, open]);

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby='alert-dialog-slide-title'
      aria-describedby='alert-dialog-slide-description'>
      <DialogTitle id='alert-dialog-slide-title'>
        Folio #{rowSelected?.folio || ''}
        <div className={styles.close}>
          <i className={`material-icons ${styles.icon}`} onClick={handleClose}>
            close
          </i>
        </div>
      </DialogTitle>
      <DialogContent className={styles.container}>
        <div>
          <div className={styles.title}>{t('status')}</div>
          <div className={styles.text}>{rowSelected?.statusDescri || ''}</div>

          <div className={styles.title}>{t('captureDate')}</div>
          <div className={styles.text}>{rowSelected?.fechaCaptura || ''}</div>

          <div className={styles.title}>{t('orderNum')}</div>
          <div className={styles.text}>{rowSelected?.pedido || ''}</div>

          {products.length > 0 && (
            <>
              <div className={styles.title}>{t('products')}</div>
              <div className={`${styles.text} ${styles.productList}`}>
                {products.map((product, key) => (
                  <div key={product.codigoProducto}>
                    {product.codigoProducto} - {product.nombre},{' '}
                    <strong>
                      {t('quantity')}: {product.unidades}
                    </strong>
                    {key < products.length - 1 && ', '}
                  </div>
                ))}
              </div>
            </>
          )}

          <div className={styles.title}>{t('afectedKit')}</div>
          <div className={styles.text}>{rowSelected?.kitAfectado || ''}</div>

          <div className={styles.title}>{t('area')}</div>
          <div className={styles.text}>
            {rowSelected?.areaDescri || ''} - {rowSelected?.area || ''}
          </div>

          {rowSelected?.deptoDescri && (
            <>
              <div className={styles.title}>Departament</div>
              <div className={styles.text}>{rowSelected?.deptoDescri || ''}</div>
            </>
          )}

          {rowSelected?.imagen && (
            <>
              <div className={styles.title}>{t('image')}</div>
              <img
                src={rowSelected.imagen}
                className={styles.chatImage}
                alt='chat'
                onClick={() => openImage(rowSelected.imagen)}
              />
            </>
          )}

          <div className={styles.title}>{t('followUp')}</div>

          {(loading && <CircularProgress className={styles.circularProgress} />) || (
            <div className={styles.conversation}>
              <div className={styles.me}>
                <div className={styles.balloon}>
                  <div className={styles.date}>{rowSelected?.fechaCaptura || ''}</div>
                  <div className={styles.chatText}>{rowSelected?.descripcion || ''}</div>
                </div>
              </div>
              <div className={styles.you}>
                <div className={styles.balloon}>
                  <div className={styles.date}>{rowSelected?.fechaCaptura || ''}</div>
                  <div className={styles.chatText}>{t('initialMessage')}</div>
                </div>
              </div>
              {comments.map((val, key) => {
                const {
                  descripcion = '',
                  fecha = '',
                  hora = '',
                  kit = '',
                  tipo = '0',
                  imagen = '',
                } = val;
                return (
                  <div className={`${(tipo === '0' && styles.me) || styles.you}`} key={key}>
                    <div className={styles.balloon}>
                      <div className={styles.date}>{`${fecha} ${hora} Kit: ${kit}`}</div>
                      <div className={styles.chatText}>{descripcion}</div>
                      {imagen && <img src={imagen} alt='chat' onClick={() => openImage(imagen)} />}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </DialogContent>
      {rowSelected?.status !== '80' && (
        <DialogActions>
          <div className={styles.actions}>
            <div className={styles.inputContainer}>
              <MUITextFieldStyle
                fullWidth
                multiline
                rows={2}
                id='description-css-outlined-kit-input'
                label={t('newMessage')}
                type='text'
                name='description'
                variant='outlined'
                value={description}
                onChange={(e) => handleDesc(e)}
              />
            </div>
          </div>
          <div className={styles.imageViewport}>
            <input
              id={styles.imagefile}
              type='file'
              name='upload'
              onChange={function (e) {
                var files = e.target.files;
                var reader = new FileReader();
                reader.onload = function () {
                  setImagesrc(reader.result);
                };
                reader.readAsDataURL(files[0]);
              }}
            />
            {imagesrc ? (
              <img src={imagesrc} onError={function () {}} alt='' />
            ) : (
              <div className={styles.instructions}>
                <i className={`material-icons ${styles.icon}`}>add_a_photo</i>
              </div>
            )}
            <div className={styles.uploadImage}>
              <span>{t('selectAnImage')}</span>
            </div>
          </div>
          <Button onClick={sendComment} color='primary'>
            {t('sendButton')}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
